import _ from 'underscore';

/**
 * Sorts the item of an array of object by the value of one property of said objects
 * (order by default);
 * @memberof core.helpers
 * @param {object[]} array The array to be sorted
 * @param {string} [sortBy='order'] The property to sort the objects in the array by.
 * @returns The ordered array.
 */
function sortBy(array, sortBy = 'order') {
  return _.sortBy(_.map(array, (item, key) => {
    item.id = item.id || key;
    return item;
  }), sortBy) || [];
}

export default sortBy;



// WEBPACK FOOTER //
// ./lmm-widget/src/helpers/sortBy.js